(() => {
  if (!customElements.get('contact-drawer')) {
    class ContactDrawer extends HTMLElement {
      constructor() {
        super();
        this.overlay = this.querySelector('[data-contact-drawer-overlay]');
        this.closeButton = this.querySelector('[data-contact-drawer-close]');
        this.closeTimer = null;
        this.openFrame = null;
        this.handleKeyup = this.handleKeyup.bind(this);
        this.close = this.close.bind(this);
      }

      connectedCallback() {
        this.overlay?.addEventListener('click', this.close);
        this.closeButton?.addEventListener('click', this.close);
        this.addEventListener('keyup', this.handleKeyup);
      }

      disconnectedCallback() {
        window.clearTimeout(this.closeTimer);
        window.cancelAnimationFrame(this.openFrame);
        this.overlay?.removeEventListener('click', this.close);
        this.closeButton?.removeEventListener('click', this.close);
        this.removeEventListener('keyup', this.handleKeyup);
      }

      handleKeyup(event) {
        if (event.code === 'Escape') this.close();
      }

      open(trigger) {
        window.clearTimeout(this.closeTimer);
        window.cancelAnimationFrame(this.openFrame);
        this.activeElement = trigger || document.activeElement;
        const heading = this.querySelector('[data-contact-drawer-heading]');
        const customHeading = trigger?.dataset.contactDrawerHeading;

        if (heading && customHeading) heading.textContent = customHeading;

        this.classList.remove('active', 'closing');
        this.classList.add('animate');
        document.body.classList.add('contact-drawer-open');

        /* Paint the off-canvas state first. Adding `active` on the following
         * frame guarantees a visible entrance transition, including after the
         * drawer has already been opened and closed once. */
        this.openFrame = window.requestAnimationFrame(() => {
          this.openFrame = window.requestAnimationFrame(() => {
            this.classList.add('active');

            const focusTarget = this.querySelector('.drawer__inner') || this.closeButton;
            if (typeof trapFocus === 'function' && focusTarget) {
              trapFocus(this, focusTarget);
            }
          });
        });
      }

      close() {
        if (!this.classList.contains('active')) return;

        window.cancelAnimationFrame(this.openFrame);
        this.classList.add('closing');
        this.classList.remove('active');
        document.body.classList.remove('contact-drawer-open');

        if (typeof removeTrapFocus === 'function') {
          removeTrapFocus(this.activeElement);
        }

        window.clearTimeout(this.closeTimer);
        this.closeTimer = window.setTimeout(() => {
          this.classList.remove('animate', 'closing');
        }, 550);
      }
    }

    customElements.define('contact-drawer', ContactDrawer);
  }

  function connectContactTriggers(root = document) {
    root.querySelectorAll('[data-contact-drawer-trigger]').forEach((trigger) => {
      if (trigger.dataset.contactDrawerConnected === 'true') return;

      trigger.dataset.contactDrawerConnected = 'true';
      trigger.addEventListener('click', (event) => {
        const drawer = document.querySelector('contact-drawer');
        if (!drawer) return;

        event.preventDefault();
        drawer.open(trigger);
      });
    });
  }

  connectContactTriggers();

  document.addEventListener('shopify:section:load', (event) => {
    connectContactTriggers(event.target);
  });
})();
